import React, { useEffect, useState, useCallback } from "react";
import {
  WidgetFrame,
  WidgetGrid,
  WidgetGridModel,
} from "../../../personal-studio-components/studio";
import ContractPaymentDebt from "../../components/ContractPaymentDebt/ContractPaymentDebt";
import OrderMaking from "./OrderMaking";

function Payment() {
  const model = new WidgetGridModel({
    widget: {
      OrderMaking: <OrderMaking />,
      ContractPaymentDebt: <ContractPaymentDebt />,
    },
    grid: [
      {
        id: "OrderMaking",
        colspan: 2,
        visible: true,
      },
      {
        id: "ContractPaymentDebt",
        colspan: 1,
        visible: true,
      },
    ],
  });

  if (!model) return null;

  return <WidgetGrid {...model} />;
}

export default Payment;
